export default "__VITE_ASSET__TPuG$VDZ__"